import { ElementRef } from '@angular/core';
import { Directive } from '@angular/core';

@Directive({
    selector: '[appHeaderIphoneArrowFix]',
    standalone: false
})
export class HeaderArrowDirective {


    constructor(el: ElementRef) {
        if (this.checkPlatform()) {
            el.nativeElement.classList.add('ios-fix-arrow-position');
        }
    }

    private checkPlatform() {
        return [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod'
        ].includes(navigator.platform);
    }

}
